const DEVICE_FINGERPRINT_STORAGE_KEY = 'hrm_device_fingerprint_v1';

/**
 * Stable per-browser fingerprint (localStorage). Used with auth-service trusted devices.
 */
export function getOrCreateDeviceFingerprint(): string {
  if (typeof window === 'undefined') return '';
  try {
    let fp = localStorage.getItem(DEVICE_FINGERPRINT_STORAGE_KEY);
    if (!fp) {
      fp = generateDeviceFingerprint();
      localStorage.setItem(DEVICE_FINGERPRINT_STORAGE_KEY, fp);
    }
    return fp;
  } catch {
    return generateDeviceFingerprint();
  }
}

export function generateDeviceFingerprint(): string {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.textBaseline = 'top';
      ctx.font = '14px Arial';
      ctx.fillText('hrm-device-fingerprint', 2, 2);
    }

    const fingerprint = {
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      screenResolution: `${screen.width}x${screen.height}`,
      canvas: canvas.toDataURL(),
    };

    const fingerprintString = JSON.stringify(fingerprint);
    let hash = 0;
    for (let i = 0; i < fingerprintString.length; i++) {
      const char = fingerprintString.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash &= hash;
    }
    return `hrm-${Math.abs(hash).toString(36)}`;
  } catch {
    return `hrm-${Date.now().toString(36)}`;
  }
}

export function getDeviceName(): string {
  const ua = navigator.userAgent;
  if (/Edg\//.test(ua)) return 'Edge';
  if (/Chrome\//.test(ua)) return 'Chrome';
  if (/Firefox\//.test(ua)) return 'Firefox';
  if (/Safari\//.test(ua)) return 'Safari';
  return 'Web Browser';
}
